<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3 v-if="form.status < 2">{{$router.currentRoute.meta.title}}</h3>
                        <h3 v-if="form.status >= 2">Editar</h3>
                    </div>
                      
                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-xl-12">
                                                <h3 class="" v-show="$router.currentRoute.name == 'CadastrarPedidos' || $router.currentRoute.name == 'EditarPedidos'">
                                                    <i class="material-icons">info</i>
                                                    Informações do abastecimento
                                                </h3>
                                                <h3 class="" v-show="$router.currentRoute.name == 'CadastrarVendas' || $router.currentRoute.name == 'EditarVendas'">
                                                    <i class="material-icons">info</i>
                                                    Informações da venda
                                                </h3>                                                
                                            </div>

                                            <div class="col-xl-6 col-xs-12 col-md-6 campo-cliente">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>
                                                        Cliente
                                                    </h5>
                                                </div>
                                                <autocomplete ref="clienteNome" :search="searchAutocompleteCliente" placeholder="Pesquise o cliente aqui (nome, CNPJ..)" aria-label="Pesquise o cliente aqui (nome, CNPJ..)" :get-result-value="getResultAutocompleteCliente" @submit="submitAutocompleteCliente"></autocomplete>
                                            </div>

                                            <div class="col-xs-12 " v-if="form.cliente">
                                                <h5 v-if="form.cliente.suspenso == 1" class="margin-bottom-15" style="font-size: 16px; background: #fff; border: 1px solid red; border-radius: 6px; padding: 10px; line-height: 130%; font-weight: bold; color: red;">
                                                    <i class="material-icons" style="font-size: inherit;">warning</i>
                                                    Cliente suspenso. Esta venda só poderá ser efetuada com pagamento via PIX ou transferência. Em caso de dúvidas, consultar administração.
                                                </h5>
                                                <h5 v-if="form.cliente.dividas == 1" class="margin-bottom-15" style="font-size: 16px; background: #fff; border: 1px solid red; border-radius: 6px; padding: 10px; line-height: 130%; font-weight: bold; color: red;">
                                                    <i class="material-icons" style="font-size: inherit;">warning</i>
                                                    Faturamento não aprovado, esta venda só poderá ser efetuada via PIX ou pagamento a vista. Em caso de dúvidas, consultar administração.
                                                </h5>                                                
                                            </div>

                                            <div class="col-xl-6 col-xs-12 col-md-6 campo-contratante" v-show="$router.currentRoute.name != 'CadastrarVendas'" v-bind:class="{'disabled': form.cod || !form.clienteCod}">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>
                                                        Piloto
                                                        <span class="float-right" v-if="$root.user.tipo == 'admin' && !form.cod">
                                                            <router-link :to="{'name': 'CadastrarUsuariosContratante', 'query': {'a': 'voltar'}}">
                                                                <i class="material-icons">add</i>
                                                                <u>Cadastrar novo</u>
                                                            </router-link>
                                                        </span>
                                                    </h5>
                                                </div>
                                                <autocomplete ref="contratanteNome" :search="searchAutocompleteContratante" placeholder="Pesquise o piloto aqui (nome, CPF..)" aria-label="Pesquise o piloto aqui (nome, CPF..)" :get-result-value="getResultAutocompleteContratante" @submit="submitAutocompleteContratante"></autocomplete>
                                            </div>

                                            <div class="col-xl-12 hidden-xs clearfix" v-show="$router.currentRoute.name == 'CadastrarVendas'"></div>

                                            <div class="col-xl-12 col-lg-12 col-xs-12" v-bind:class="{'disabled': form.cod || !form.clienteCod}">

                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Qual o produto?</h5>
                                                </div>

                                                <!-- <button class="button margin-bottom-15 margin-right-5" v-for="item in catalogo.itens" type="button" v-if="item.cor" style="width: 48%" :style="{'background-color': item.cor}" v-on:click="form.catalogoCod = item.cod;"> -->
                                                <div class="row">
                                                    <div class="col-lg-3 col-xs-6" v-for="item in catalogo.itens">
                                                        <button class="button margin-bottom-15" type="button" style="width: 100%; height: 44px; overflow: hidden; word-break: break-all; white-space: nowrap; text-overflow: ellipsis;" :style="{'background-color': item.cor}" v-on:click="form.catalogoCod = item.cod;">
                                                            <i v-show="form.catalogoCod == item.cod" class="material-icons">check_circle</i>
                                                            {{item.nome.toUpperCase()}}
                                                        </button>
                                                    </div>
                                                </div>
                                                                                             
                                            </div>                                                    
                                            
                                            <div class="col-xl-12 margin-bottom-15" v-if="alertaEstoqueMedicao">
                                                <h5 style="font-size: 16px;">
                                                    <i class="material-icons" style="font-size: inherit;">warning</i>
                                                    A emissão de novas ordens de abastecimento para <b>{{form.catalogo.nome.toUpperCase()}}</b> está bloqueada. Faça a medição do tanque para desbloquear.
                                                </h5>
                                            </div>

                                            <div class="col-xl-4 col-xs-12 col-lg-6 col-md-5" v-show="$root.user.tipo == 'admin' || $root.user.tipo == 'gerencial'" v-bind:class="{'disabled': form.cod || !form.clienteCod || !form.catalogoCod}">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Filial</h5>
                                                </div>
                                                <select class="with-border" v-model="form.empresaCod">
                                                    <option value="" disabled selected hidden>Selecione aqui..</option>
                                                    <option v-for="item in empresas.itens" :value="item.cod">{{item.nome}}</option>
                                                </select>                                                   
                                            </div>
                                            
                                            <!-- <div class="col-xl-12 hidden-xs clearfix" v-show="$router.currentRoute.name != 'CadastrarVendas'"></div> -->


                                            <div class="col-xl-4 col-xs-6 col-lg-6 col-md-5"  v-bind:class="{'disabled': !form.clienteCod || alertaEstoqueMedicao || !form.catalogoCod || !form.empresaCod || form.status >= 2}">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Estoque</h5>
                                                </div>
                                                <select class="with-border" v-model="form.estoqueCod">
                                                    <option value="" disabled selected hidden>Selecione aqui..</option>
                                                    <option v-for="item in estoque.itens" v-if="item.empresaCod == form.empresaCod && item.catalogoCod == form.catalogoCod" :value="item.cod">{{item.nome}}</option>
                                                </select>                                                   
                                            </div>    

                                            <div class="col-xl-2 col-xs-4 col-md-3" v-bind:class="{'disabled': !form.clienteCod || alertaEstoqueMedicao || !form.catalogoCod || !form.empresaCod || form.status >= 2}">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Quantidade</h5>
                                                </div>
                                                <input type="number" @keydown="$event.key === '-' ? $event.preventDefault() : null" class="with-border" placeholder="_____" v-model="form.quantidade" min="0">
                                            </div>  

                                            <div class="col-xl-2 col-xs-5 col-md-3" v-bind:class="{'disabled': !form.clienteCod || alertaEstoqueMedicao || !form.catalogoCod || !form.empresaCod}">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Valor unitário</h5>
                                                </div>
                                                <div v-if="form.catalogo">
                                                    <money v-model="form.catalogo.valor" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-bind="$root.config.money" class="input-text with-border"></money>
                                                </div>
                                            </div>  

                                            <div class="col-xl-2 col-xs-5 col-md-3" v-bind:class="{'disabled': !form.clienteCod || alertaEstoqueMedicao || !form.catalogoCod || !form.empresaCod || !form.quantidade}">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Valor total</h5>
                                                </div>
                                                <money v-model="form.total" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-bind="$root.config.money" class="input-text with-border"></money>
                                            </div>  

                                            <!-- <div class="col-xl-12 hidden-xs clearfix" v-show="$router.currentRoute.name != 'CadastrarVendas'"></div> -->

                                            <div class="col-xl-4 col-xs-8 col-lg-5 col-md-4" v-show="$router.currentRoute.name != 'CadastrarVendas'" v-bind:class="{'disabled': !form.clienteCod || alertaEstoqueMedicao || !form.catalogoCod || !form.empresaCod}">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Qual o prefixo da aeronave?</h5>
                                                </div>
                                                <input type="text" class="with-border" placeholder="_______" style="text-transform: uppercase;" v-model="form.auxiliar1">
                                            </div>

                                            <div class="col-xl-3 col-xs-7 col-md-4" v-bind:class="{'disabled': form.status >= 2}" v-show="form.agendamento && $router.currentRoute.name != 'CadastrarVendas'">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Data do agendamento</h5>
                                                </div>
                                                <input type="date" class="with-border" data-placeholder="___ /____ /_____" v-model="form.data" required="">
                                            </div>

                                            <div class="col-xl-2 col-xs-5 col-md-3 col-lg-3" v-bind:class="{'disabled': form.status >= 2}" v-show="form.agendamento && $router.currentRoute.name != 'CadastrarVendas'">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Horário</h5>
                                                </div>
                                                <input type="time" class="with-border" data-placeholder="__ : __" v-model="form.horaInicio" required="">
                                            </div>
                                            
                                            <div class="col-xl-12" v-bind:class="{'disabled': !form.clienteCod || alertaEstoqueMedicao || !form.catalogoCod || !form.empresaCod}" v-show="$router.currentRoute.name != 'CadastrarVendas'">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Observações</h5>
                                                </div>
                                                <textarea class="with-border" style="min-height: 80px;" placeholder="Escreva aqui..." v-model="form.observacoes"></textarea>
                                            </div>

                                            <div class="col-xl-12" v-if="form.cod || !form.agendamento || $router.currentRoute.name == 'CadastrarVendas'" v-bind:class="{'disabled': !form.clienteCod || alertaEstoqueMedicao || !form.catalogoCod || !form.empresaCod || !form.quantidade}">
                                                <div class="row">
                                                    <div class="col-xl-12 margin-top-20">
                                                        
                                                        <h3 class="">
                                                            <i class="material-icons">insert_drive_file</i>
                                                            Ordem digital
                                                        </h3>
                                                    </div>
                                                    <div class="col-xl-3 col-xs-5 col-md-3 col-lg-3" v-bind:class="{'disabled': form.status >= 2}">
                                                        <div class="submit-field margin-bottom-0">
                                                            <h5>Nº da ordem</h5>
                                                        </div>
                                                        <input type="number" @keydown="$event.key === '-' ? $event.preventDefault() : null" class="with-border" placeholder="" v-model="form.numero" min="0">
                                                    </div> 
                                                    <div class="col-xl-3 col-xs-5 col-md-3 col-lg-13">
                                                        <div class="submit-field margin-top-41 margin-bottom-0">
                                                            <!-- <h5>Pago?</h5> -->
                                                            <div class="checkbox margin-bottom-0">
                                                                <input type="checkbox" id="pedido-pago" v-model="form.pago" true-value="1" false-value="0">
                                                                <label for="pedido-pago"><span class="checkbox-icon"></span> Pago</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-12 clearfix"></div>
                                                    <div class="col-xl-6 col-xs-12 col-lg-5 col-md-4">
                                                        <div class="submit-field margin-bottom-0">
                                                            <h5>Finalidade</h5>
                                                        </div>
                                                        <input type="text" class="with-border" placeholder="Escreva aqui.." v-model="form.finalidade">
                                                    </div>
                                                    <div class="col-xl-3 col-xs-7 col-md-4" v-bind:class="{'disabled': form.status >= 2}">
                                                        <div class="submit-field margin-bottom-0">
                                                            <h5>Data</h5>
                                                        </div>
                                                        <input type="date" class="with-border" placeholder="" v-model="form.data">
                                                    </div>                                             
                                                    <div class="col-xl-3 col-xs-5 col-md-3 col-lg-3" v-bind:class="{'disabled': form.status >= 2}">
                                                        <div class="submit-field margin-bottom-0">
                                                            <h5>Nº da bomba</h5>
                                                        </div>
                                                        <input type="number" @keydown="$event.key === '-' ? $event.preventDefault() : null" class="with-border" placeholder="" v-model="form.estoqueNumero" min="0">
                                                    </div> 

                                                    <div class="col-xl-6 col-xs-12" v-show="form.assinatura" v-bind:class="{'disabled': form.status >= 2}">
                                                        <div class="submit-field margin-bottom-0">
                                                            <h5>Assinatura</h5>
                                                        </div>
                                                        <img class="assinatura-preview">
                                                    </div>                                                     

                                                    <div class="col-xl-12 margin-top-0">
                                                        
                                                        <button v-if="!form.assinatura && $router.currentRoute.name != 'CadastrarVendas'" v-on:click="openAssinatura()" type="button" style="min-width: 300px;" class="button gray block-mobile margin-bottom-20">
                                                            <i class="material-icons">edit</i>
                                                            Incluir assinatura
                                                        </button>
                                                        <button v-if="form.assinatura && form.status < 2" v-on:click="openAssinatura()" type="button" style="min-width: 300px; opacity: 0.6;" class="button gray block-mobile margin-bottom-20">
                                                            <i class="material-icons">edit</i>
                                                            Editar assinatura
                                                        </button>                                                        

                                                        <button v-show="form.catalogoCod" v-on:click="mostrarItens = (mostrarItens ? false : true)" type="button" style="min-width: 150px;" class="button gray block-mobile margin-bottom-20">
                                                            <i class="material-icons" v-show="!mostrarItens">arrow_drop_down</i>
                                                            <i class="material-icons" v-show="mostrarItens">arrow_drop_up</i>
                                                            {{form.status >= 2 ? "Ver produtos" : "Incluir produtos"}}
                                                        </button>
                                                    </div>

                                                    <div class="col-xl-8 col-xs-12 col-lg-6 margin-top-0" v-show="mostrarItens">
                                                        <div class="table-scroll" style="overflow-x: scroll;">

                                                            <table class="table table-bordered table-bordered-default hidden-md hidden-lg hidden-xl">
                                                                <tbody>
                                                                    <tr v-if="form.catalogo" class="disabled" style="display: inline-block;">
                                                                        <td data-label="Descrição" style="display: block !important; width: 100%; background: #f7f7f7;">
                                                                            {{form.catalogo.nome.toUpperCase()}}
                                                                        </td>
                                                                        <td data-label="Qtde">
                                                                            <small>Qtde</small>
                                                                            <input v-bind:class="{'disabled': form.status >= 2}" type="number" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-model="form.quantidade" min="0">
                                                                        </td>
                                                                        <td data-label="Unit.">
                                                                            <small>Unit.</small>
                                                                            <money v-model="form.catalogo.valor" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-bind="$root.config.money" class="input-text with-border"></money>
                                                                            <!-- <input type="tel" v-model="form.catalogo.valor" readonly=""> -->
                                                                        </td>
                                                                        <td data-label="Total">
                                                                            <small>Total</small>
                                                                            <money v-model="form.catalogo.total" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-bind="$root.config.money" class="input-text with-border"></money>
                                                                            <!-- <input type="tel" v-model="form.catalogo.total" readonly=""> -->
                                                                        </td>                                                                                                                                        
                                                                    </tr>
                                                                    <tr v-for="(item, index) in form.itens" v-if="item.cod != form.catalogoCod" style="display: inline-block;">
                                                                        <td data-label="Descrição" style="display: block !important; width: 100%; background: #f7f7f7;">
                                                                            {{item.nome.toUpperCase()}}
                                                                        </td>
                                                                        <td data-label="Qtde">
                                                                            <small>Qtde</small>
                                                                            <input v-bind:class="{'disabled': form.status >= 2}" type="number" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-model="item.quantidade" min="0">
                                                                        </td>
                                                                        <td data-label="Unit.">
                                                                            <small>Unit.</small>
                                                                            <!-- <input type="tel" v-model="item.valor"> -->
                                                                            <money v-model="item.valor" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-bind="$root.config.money" class="input-text with-border"></money>
                                                                        </td>
                                                                        <td data-label="Total">
                                                                            <small>Total</small>
                                                                            <!-- <input type="tel" v-model="item.total"> -->
                                                                            <money v-model="item.total" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-bind="$root.config.money" class="input-text with-border"></money>
                                                                        </td>                                                                                                                                     
                                                                    </tr>
                                                                </tbody>
                                                            </table>                                                                    
                                                            <table class="table table-bordered table-bordered-default hidden-md hidden-lg hidden-xl margin-top-15">
                                                                <tbody>                                                                    
                                                                    <tr>
                                                                        <td style="text-align: right; font-size: 16px;" colspan="2">
                                                                            Total (R$) 
                                                                        </td>
                                                                        <td style="text-align: center; font-size: 16px;">
                                                                            <money v-model="form.total" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-bind="$root.config.money" class="input-text with-border"></money>
                                                                            <!-- {{form.total | toMoney}} -->
                                                                        </td>                                                                    
                                                                    </tr>
                                                                </tbody>
                                                            </table>

                                                            <table class="table table-bordered table-bordered-default table-responsive hidden-xs">
                                                                <thead>
                                                                    <th style="width: 90px; min-width: 90px;">
                                                                        Qtde
                                                                    </th>
                                                                    <th>
                                                                        Descrição
                                                                    </th>
                                                                    <th style="width: 120px; min-width: 120px;">
                                                                        Unit.
                                                                    </th>
                                                                    <th style="width: 120px; min-width: 120px;">
                                                                        Total
                                                                    </th>                                                                
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-if="form.catalogo" class="disabled">
                                                                        <td data-label="Qtde">
                                                                            <input v-bind:class="{'disabled': form.status >= 2}" type="number" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-model="form.quantidade" min="0">
                                                                        </td>
                                                                        <td data-label="Descrição">
                                                                            <input type="text" v-model="form.catalogo.nome" style="pointer-events: none;" readonly="">
                                                                        </td>
                                                                        <td data-label="Unit.">
                                                                            <money v-model="form.catalogo.valor" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-bind="$root.config.money" class="input-text with-border"></money>
                                                                            <!-- <input type="tel" v-model="form.catalogo.valor" readonly=""> -->
                                                                        </td>
                                                                        <td data-label="Total">
                                                                            <money v-model="form.catalogo.total" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-bind="$root.config.money" class="input-text with-border"></money>
                                                                            <!-- <input type="tel" v-model="form.catalogo.total" readonly=""> -->
                                                                        </td>                                                                                                                                        
                                                                    </tr>
                                                                    <tr v-for="(item, index) in form.itens" v-if="item.cod != form.catalogoCod">
                                                                        <td data-label="Qtde">
                                                                            <input v-bind:class="{'disabled': form.status >= 2}" type="number" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-model="item.quantidade" min="0">
                                                                        </td>
                                                                        <td data-label="Descrição">
                                                                            <input type="text" v-model="item.nome" style="pointer-events: none;" readonly="">
                                                                        </td>
                                                                        <td data-label="Unit.">
                                                                            <!-- <input type="tel" v-model="item.valor"> -->
                                                                            <money v-model="item.valor" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-bind="$root.config.money" class="input-text with-border"></money>
                                                                        </td>
                                                                        <td data-label="Total">
                                                                            <!-- <input type="tel" v-model="item.total"> -->
                                                                            <money v-model="item.total" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-bind="$root.config.money" class="input-text with-border"></money>
                                                                        </td>                                                                                                                                     
                                                                    </tr>
                                                                    <tr>
                                                                        <td style="text-align: right; font-size: 16px;" colspan="3">
                                                                            Total (R$) 
                                                                        </td>
                                                                        <td style="text-align: center; font-size: 16px;">
                                                                            <money v-model="form.total" @keydown="$event.key === '-' ? $event.preventDefault() : null" v-bind="$root.config.money" class="input-text with-border"></money>
                                                                            <!-- {{form.total | toMoney}} -->
                                                                        </td>                                                                    
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div class="col-xl-12 margin-bottom-30 margin-top-20" v-bind:class="{'disabled': alertaEstoqueMedicao || !form.clienteCod || !form.catalogoCod || !form.empresaCod || !form.quantidade}">
                                                
                                                <div class="hr"></div>
                                                
                                                <button type="submit" class="button big green block-mobile" v-bind:class="{'disabled': loading.submit }" v-if="form.status >= 2">
                                                    <i class="material-icons" v-show="!form.cod">save</i>
                                                    <i class="material-icons" v-show="form.cod">check_circle</i>
                                                    Salvar alterações
                                                </button>

                                                <button type="submit" class="button big green block-mobile" v-bind:class="{'disabled': loading.submit }" v-if="form.status < 2 && ($router.currentRoute.name == 'CadastrarPedidos' || $router.currentRoute.name == 'EditarPedidos')">
                                                    <i class="material-icons" v-show="!form.cod">save</i>
                                                    <i class="material-icons" v-show="form.cod">check_circle</i>
                                                    {{ form.cod ? 'Concluir abastecimento' : 'Cadastrar abastecimento' }}
                                                </button>

                                                <button type="submit" class="button big green block-mobile" v-bind:class="{'disabled': loading.submit }" v-if="form.status < 2 && ($router.currentRoute.name == 'CadastrarVendas' || $router.currentRoute.name == 'EditarVendas')">
                                                    <i class="material-icons" v-show="!form.cod">save</i>
                                                    <i class="material-icons" v-show="form.cod">check_circle</i>
                                                    {{ form.cod ? 'Concluir venda' : 'Cadastrar venda' }}
                                                </button>

                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div id="modal-assinatura" class="modal" ontouchmove="return false">

            <div class="row" ontouchmove="return false">
                <div class="col-lg-12" ontouchmove="return false">
                    <div class="welcome-text padding-top-20" ontouchmove="return false">
                            
                        <button type="button" class="button small gray" onclick="window.__app.$children[0].$children[0].limparAssinatura()">
                            <i class="material-icons" style="color: red;">delete</i>
                            Limpar
                        </button>
                        <button type="button" class="button small transparent" onclick="window.__app.$children[0].$children[0].fecharAssinatura()">
                            <i class="material-icons">close</i>
                        </button>                                                
                        <button type="button" class="button small green" onclick="window.__app.$children[0].$children[0].salvarAssinatura()">
                            <i class="material-icons">save</i>
                            Salvar
                        </button> 

                        <h3>
                            <i class="material-icons">verified_user</i>
                            Por favor, assine abaixo:
                        </h3>
                    </div>
                    <canvas></canvas>
                </div>
            </div>
        </div>        


        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'GerenciarPedidos',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        return {
            "requestAutocomplete":  null,
            "loading": {
                "submit":           false
            },
            "alertaEstoqueMedicao": false,
            "medicao":              {
                "catalogoCod":      null,
                "empresaCod":       null
            },
            "mostrarItens":         false,
            "empresas": {
                "itens":            []
            },
            "clientes": {
                "itens":            []
            },
            "usuarios": {
                "itens":            []
            },            
            "catalogo": {
                "ativo":            null,
                "itens":            []
            },  
            "estoque": {
                "itens":            []
            },
            "estoqueMedicao": {
                "itens":            []
            },            
            "precosEspeciais": {
                "itens":            []
            },                                      
            "form": {
                "_cod":             "",
                "_token":           "",
                "catalogoCod":      "",
                "observacoes":      "",
                "estoqueCod":       "",
                "catalogo":         null,
                "valor":            "",
                "total":            "",
                "pago":             0,
                "status":           0,
                "quantidade":       "",
                "finalidade":       "",
                "estoqueNumero":    0,
                "pontos":           0,
                "contratante":      {
                    "nome":         "",
                },
                "cliente":      {
                    "nome":         "",
                },                
                "empresaCod":       "",
                "itens":            [],
                "usuarioCod":       "",
                "clienteCod":       "",
                "auxiliar1":        "",
                "data":             "",
                "hora":             "",
                "agendamento":      0,
                "imagem":           "",
                "doc":              "",
                "telefone":         ""
            }            
        }
    },
    filters: {
        toMoney: function(value) {
            if (value) {
                return parseFloat(value).toLocaleString('pt-br', {minimumFractionDigits: 2});                
            } else {
                return "0,00";
            }
        },        
    },     
    watch: {
        "form.auxiliar1": function(val) {
            var self = this;
            if (val) {
                self.form.auxiliar1 = val.toUpperCase();
            }
        },        
        "form.itens": {
            deep: true,
            handler: function(val) {
                var self = this;
                self.atualizarValorTotal();
            }
        },
        "form.catalogo.valor": {
            handler: function(val) {
                var self = this;
                setTimeout(function() {
                    self.atualizarQuantidade();
                }, 10);
            }
        },               
        "form.clienteCod": function(val) {
            var self = this;
            self.atualizarQuantidade();
        },
        "form.catalogoCod": function(val) {
            var self = this;
            if (val) {
                var catalogo = null;
                self.catalogo.itens.forEach(function(item) {
                    if (item.cod == self.form.catalogoCod) catalogo = item;
                });             
                if (catalogo) {
                    self.form.catalogo = catalogo;
                }   
            }

            self.atualizarEstoque();
            self.atualizarQuantidade();
            self.atualizarItens();
        },        
        "form.empresaCod": function(val) {
            var self = this;
            self.atualizarEstoque();
            self.atualizarQuantidade();
            self.atualizarEmpresa();
        },
        "form.estoqueCod": function(val) {
            var self = this;
            self.atualizarQuantidade();
        },        
        "form.quantidade": function(val) {
            var self = this;

            if (val < 0) {
                self.form.quantidade = 0;
            }

            self.atualizarQuantidade();
            self.atualizarItens();
        },          
    },
    methods: {
        atualizarEmpresa: function() {
            var self            = this;        
            if (self.form.empresaCod) {
                var empresa = (self.empresas.itens.filter(function(item) {
                    if (item.cod == self.form.empresaCod) return item;
                })[0] || null);
                // if (empresa) { validacao antiga
                if (empresa) {
                    var atualizar = false;
                    if (self.form.datahora) {
                        if (self.form.status < 2) {
                            atualizar = true;
                        }
                    } else {
                        atualizar = true;
                    }
                    if (atualizar) {
                        console.log("ATUALIZAR NUMERO + 1" + self.form.numero); 
                        self.form.numero = (parseFloat(empresa.pedidosNumeroInicio) + 1);
                    }
                }
            }    
        },
        salvarAssinatura: function() {
            var self            = this;
            if (!self.signaturePad.isEmpty()) {
                self.signaturePad.removeBlanks();
                self.form.assinatura    = self.signaturePad.toDataURL();
                $(".assinatura-preview").attr("src", self.form.assinatura);                   
                $(".assinatura-preview").show();
            } else {
                self.form.assinatura    = null;
                $(".assinatura-preview").attr("src", "");                   
                $(".assinatura-preview").hide();
            }
            self.$forceUpdate();
            self.fecharAssinatura();
        },
        fecharAssinatura: function() {
            var self            = this;
            self.modalAssinatura.close();
        },
        limparAssinatura: function() {
            var self            = this;
            self.signaturePad.clear(); 
        },
        openAssinatura: function() {
            var self = this;
            loading.show();
            self.modalAssinatura   = new tingle.modal({
                footer:         false,
                stickyFooter:   false,
                closeMethods:   [],
                closeLabel:     "Fechar",
                cssClass:       ["modal-assinatura"],
                onClose: function() {
                    console.log('onClose');
                },
                beforeClose: function() {
                    console.log("beforeClose");
                    if (window.cordova) screen.orientation.lock('portrait');
                    return true;
                    return false; 
                }                
            });   
            self.modalAssinatura.setContent(document.querySelector('#modal-assinatura').innerHTML);          
            self.modalAssinatura.open();
            if (window.cordova) screen.orientation.lock('landscape');

            setTimeout(function() {
                var canvas          = $(".modal-assinatura canvas")[0];
                self.signaturePad   = new SignaturePad(canvas);

                function resizeCanvas() {
                    loading.show();
                    setTimeout(function() {
                        var ratio       = Math.max(window.devicePixelRatio || 1, 1);
                        canvas.width    = canvas.offsetWidth * ratio;
                        canvas.height   = canvas.offsetHeight * ratio;
                        canvas.getContext("2d").scale(ratio, ratio);
                        self.signaturePad.clear();
                        loading.hide();
                    }, 0);
                }

                window.addEventListener("resize", resizeCanvas);
                resizeCanvas();
                var ctx             = canvas.getContext('2d');
                canvas.addEventListener( 'touchstart', onTouchStart, false);
                function onTouchStart(e) {} 
                loading.hide();
            }, 1000);
        },        
        submitAutocompleteCliente: function(obj) {
            console.log("submitAutocompleteCliente", obj)
            var self = this;
            self.form.clienteCod    = obj.cod;
            self.form.cliente       = obj;
            self.$forceUpdate();
            console.log("Setou form", self.form)
        },
        submitAutocompleteContratante: function(obj) {
            console.log("submitAutocompleteContratante", obj)
            var self = this;
            self.form.usuarioCod    = obj.cod;
            self.form.contratante   = obj;
            self.$forceUpdate();
            console.log("Setou form", self.form)
        },
        escolherImagem: function() {
            var self = this;
            if (window.cordova.platformId == "ios") {
                $(".uploadButton-button").click();        
            } else {
                navigator.notification.confirm(
                    '', 
                    function(buttonIndex) {
                        if (buttonIndex == 1) {
                            navigator.camera.getPicture(function(imageData) {
                                self.form.imagem = "data:image/jpeg;base64," + imageData;
                            }, function(message){
                            }, {
                                quality: 35,
                                saveToPhotoAlbum: true,
                                destinationType: Camera.DestinationType.DATA_URL,
                                targetWidth: 1000,
                                correctOrientation: true,
                                targetHeight: 0
                            });                        
                        }
                        if (buttonIndex == 2) {
                            $(".uploadButton-button").click();
                        }                    
                    },          
                    'Escolher foto',   
                    ['Câmera','Galeria'] 
                );            
            }

        },
        getResultAutocompleteContratante: function(result) {
          return result.nome;
        },        
        getResultAutocompleteCliente: function(result) {
          return (result.razaoSocial ? result.razaoSocial : result.nome);
        },        
        searchAutocompleteContratante: function(val, all) {
            var self = this;
            return new Promise(function(resolve, reject) {

                if (!val) {
                    resolve([]);
                    return false;
                }

                if (!self.$root.internet.online) {
                    console.log("Nao esta online, entao busca da db local");

                    var clean = function(val) {
                        return (val ? val : "").toLowerCase().replace(/[^a-zA-Z0-9]/g, "").trim();
                    }

                    var itens = [];                        
                    var search= clean(val);

                    self.usuarios.itens.forEach(function(item) {
                        if (clean(item.nome).indexOf(search) != -1 || clean(item.doc).indexOf(search) != -1) {
                            itens.push(item);
                        }
                    });
                    console.log("Resultado pesquisa itens", itens)
                    resolve(itens);

                 
                } else {

                    if (self.requestAutocomplete) {
                        self.requestAutocomplete.cancel(); 
                    }

                    self.requestAutocomplete = axios.CancelToken.source();  
                    
                    var form = {
                        "db":               "usuarios",                    
                        "params": {
                            "_cod":         self.$root.user.cod, 
                            "_token":       self.$root.user.token,
                            "tipo":         "contratante",
                            "all":          (all || false),
                            "autocomplete": true,
                            "pesquisa":     val
                        },
                        "cancelToken":      self.requestAutocomplete.token  
                    };

                    axios.get("api/usuarios.php", form)
                    .then(response => {
                        
                        resolve(response.data.result.itens);
      
                    })
                    .catch(error => {
                        loading.hide();
                        reject(error);
                    }); 
                }
            });
        },
        getUsuariosDB: function() {
            console.log("getUsuariosDB()");
            var self = this;
            return new Promise(function(resolve, reject) {
                self.$root.db["usuarios"].query(function(doc) {
                    if (doc.request.all) {
                        emit(doc);
                    }
                }, {include_docs : true}).then(function (result) {
                    console.log("usuarios find()", "ok:", result);
                    if (result.rows.length > 0) {
                        self.usuarios.itens     = result.rows[0].doc.result.result.itens;
                    } else {
                        self.usuarios.itens     = [];
                    }
                    self.$forceUpdate();

                    console.log("Setou usuarios:", self.usuarios)
                    resolve(self.usuarios.itens)

                }).catch(function (err) {
                    console.log("usuarios find()", "erro:", err);
                    resolve(err);
                });              
            });              
        },
        getClientesDB: function() {
            console.log("getClientesDB()");
            var self = this;
            return new Promise(function(resolve, reject) {
                self.$root.db["clientes"].query(function(doc) {
                    if (doc.request.all) {
                        emit(doc);
                    }
                }, {include_docs : true}).then(function (result) {
                    console.log("clientes find()", "ok:", result);
                    if (result.rows.length > 0) {
                        self.clientes.itens     = result.rows[0].doc.result.result.itens;
                    } else {
                        self.clientes.itens     = [];
                    }
                    self.$forceUpdate();

                    console.log("Setou clientes:", self.clientes)
                    resolve(self.clientes.itens)

                }).catch(function (err) {
                    console.log("clientes find()", "erro:", err);
                    resolve(err);
                });              
            });              
        },
        searchAutocompleteCliente: function(val, all) {
            var self = this;
            return new Promise(function(resolve, reject) {
                if (!val) {
                    resolve([]);
                    return false;
                }
                if (!self.$root.internet.online) {
                    console.log("Nao esta online, entao busca da db local");

                    var clean = function(val) {
                        return (val ? val : "").toLowerCase().replace(/[^a-zA-Z0-9]/g, "").trim();
                    }

                    var itens = [];                        
                    var search= clean(val);

                    self.clientes.itens.forEach(function(item) {
                        if (clean(item.nome).indexOf(search) != -1 || clean(item.doc).indexOf(search) != -1 || clean(item.razaoSocial).indexOf(search) != -1) {
                            itens.push(item);
                        }
                    });
                    console.log("Resultado pesquisa itens", itens)
                    resolve(itens);

                 
                } else {
                    if (self.requestAutocomplete) {
                        self.requestAutocomplete.cancel(); 
                    }

                    self.requestAutocomplete = axios.CancelToken.source();  
                    
                    var form = {
                        "db":               "clientes",
                        "params": {
                            "_cod":         self.$root.user.cod, 
                            "_token":       self.$root.user.token,
                            "page":         1,
                            "autocomplete": true,
                            "all":          (all || false),
                            "pesquisa":     val
                        },
                        "cancelToken":      self.requestAutocomplete.token  
                    };

                    axios.get("api/clientes.php", form)
                    .then(response => {
                        
                        resolve(response.data.result.itens);
      
                    })
                    .catch(error => {
                        loading.hide();
                        reject(error);
                    }); 
                }

            });
        },        
        atualizarEstoque: function() {
            var self = this;
            if (self.form.catalogoCod && self.form.empresaCod) {
                var estoque     = null;
                var estoque2    = null;
                if (self.estoque.itens.length > 0) {
                    self.estoque.itens.forEach(function(item) {
                        if (item.empresaCod == self.form.empresaCod && item.catalogoCod == self.form.catalogoCod && !estoque) {
                            if (item.tipo == "cta" && self.$route.name != "EditarVendas" && self.$route.name != "CadastrarVendas") {
                                estoque = item.cod;
                            }
                            if (item.tipo == "tanque" && (self.$route.name == "EditarVendas" || self.$route.name == "CadastrarVendas")) {
                                estoque = item.cod;
                            }                        
                            estoque2 = item.cod;
                        }
                    });
                    if (!estoque && estoque2) {
                        estoque     = estoque2;
                    }
                    self.form.estoqueCod = estoque;
                }
                self.atualizarEstoqueMedicao();
            }
        },
        atualizarEstoqueMedicao: function() {
            var self = this;
            return new Promise(function(resolve, reject) {
                setTimeout(function() {
                    if (self.$root.internet.online && (self.medicao.catalogoCod != self.form.catalogoCod || self.medicao.empresaCod != self.form.empresaCod)) {
                        console.log("Valida se possui medicao no mes para este produto", self.medicao);

                        self.medicao.catalogoCod    = self.form.catalogoCod;
                        self.medicao.empresaCod     = self.form.empresaCod;
                        self.$forceUpdate();

                        if (self.form.catalogo) {
                            if (self.form.catalogo.estoque == "0") {
                                console.log("Esse produto nao possui gerenciamento de estoque")
                                self.alertaEstoqueMedicao = false;
                                self.$forceUpdate();
                                resolve(true);
                                return false;
                            }
                        }

                        loading.show();
                        self.getEstoqueMedicao().then(function(result) {

                            var medicao = (self.estoqueMedicao.itens.filter(function(item) {
                                if (item.catalogoCod == self.form.catalogoCod && item.empresaCod == self.form.empresaCod) return item;
                            })[0] || null);
                            console.log("Possui medicao?", medicao);

                            var estoque = self.estoque.itens.filter(function(item) {
                                if (item.empresaCod == self.form.empresaCod && self.form.catalogoCod == item.catalogoCod && item.tipo == "tanque") return item;
                            });

                            console.log("Possui tanque nessa filial?", estoque)

                            if (estoque.length == 0) {
                                medicao = true;
                            }

                            loading.hide();
                            self.alertaEstoqueMedicao = (medicao ? false : true);

                            // self.medicao    = {
                            //     "catalogoCod": self.form.catalogoCod,
                            //     "catalogoCod": self.form.catalogoCod
                            // };

                            if (!medicao) {
                                alert("A emissão de novas ordens de abastecimento para " + self.form.catalogo.nome.toUpperCase() + " está bloqueada. Faça a medição do tanque para desbloquear.")
                                reject(true);
                            }

                            self.$forceUpdate();                        

                        }).catch(function(error) {
                            loading.hide();
                            console.log("Erro ao buscar medicao", error);
                            reject(error);
                        });

                    } else {
                        if (!self.$root.internet.online) {
                            self.alertaEstoqueMedicao = false;
                            self.$forceUpdate();
                        }
                        console.log("Não busca medicao", self.form.catalogoCod, self.medicao)
                        resolve(true);
                    }            
                }, 100);
            });                              
        },
        atualizarValorTotal: function() {

            var self    = this;
            var total   = 0;
            total       = total + self.form.catalogo.total;
            console.log("Catalogo total", total);
            self.form.itens.forEach(function(item, i) {
                if (item.quantidade > 0 && item.cod != self.form.catalogo.cod) {
                    total                       = total + (item.quantidade * item.valor);
                    self.form.itens[i].total    = (item.quantidade * item.valor);
                }
            });
            console.log("atualizarValorTotal()", total)
            self.form.total     = total;

        },
        atualizarQuantidade: function() {
            var self        = this;
            if (self.form.clienteCod && self.form.catalogoCod && self.form.empresaCod) {

                var catalogo = null;
                self.catalogo.itens.forEach(function(item) {
                    if (item.cod == self.form.catalogoCod) {
                        catalogo = item;
                    }
                });

                self.precosEspeciais.itens.forEach(function(item) {
                    if (item.catalogoCod == self.form.catalogoCod && item.empresaCod == self.form.empresaCod && item.clienteCod == self.form.clienteCod) {
                        if (catalogo) {
                            catalogo.valor    = item.valor;
                        }
                    }
                });

                if (catalogo) {
                    self.form.catalogo          = catalogo;
                    self.form.catalogo.total    = ((catalogo.valor) * self.form.quantidade);
                    self.atualizarValorTotal();
                }
            }
            if (self.form.quantidade && self.form.estoqueCod) {
                var estoque = (self.estoque.itens.filter(function(item) {
                    if (item.cod == self.form.estoqueCod) return item;
                })[0] || null);
                if (estoque && self.form.status < 2) {
                    self.form.estoqueNumero = (parseFloat(estoque.numero) + parseFloat(self.form.quantidade));
                }
            }

            self.atualizarPontos();

        },
        getBase64Imagem: function(event) {
            var self            = this;

            if (event.target.files[0]) {
                loading.show();
                reduceFileSize(event.target.files[0], 500*1024, 1000, Infinity, 0.9, blob => {
                    blobToBase64(blob, function(result) {
                        loading.hide();
                        self.form.imagem    = result;
                    });
                }); 
            }   
        },         
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;

            var form            = JSON.parse(JSON.stringify(self.form));

            if (self.$route.name == "EditarPedidos" && !self.form.clienteCod) {
                alert("Informe o campo cliente");
                return false;
            }

            form.itens.forEach(function(item, i) {
                if (item.cod == form.catalogoCod) {
                    form.itens[i].quantidade    = form.quantidade;
                    form.itens[i].valor         = form.catalogo.valor;
                    form.itens[i].total         = form.catalogo.total;
                }
            })

            console.log("submit()", e, form, JSON.stringify(form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a   = "post";
            var url = "api/agendamento.php";
            if (form.cod) {
                a   = "put";
                form.acao = "finalizar";
            }

            if (self.$route.name == "EditarVendas" || self.$route.name == "CadastrarVendas") {
                url = "api/pedidos.php";
            }

            var params = {
                "status":   "pendente",
                "url":      url,
                "method":   a
            };
            self.$root.salvarDB("pedidosRascunho", form, params, form._id).finally(function(r) {

                console.log("pedidosRascunho>", r)

                if (!self.$root.internet.online) {
                    alert("Você está sem conexão com a internet. Os dados foram salvos e você poderá realizar o reenvio mais tarde.");  
                    self.$root.go("Dashboard");
                    return false;  
                }

                self.atualizarEstoqueMedicao().then(function(r) {

                    axios[a](url, form)
                    .then(response => {
                        
                        self.loading.submit = false;
                        console.log("submit() response", response)

                        self.$root.db["pedidosRascunho"].get(self.form._id).then(function (doc) {
                            return self.$root.db["pedidosRascunho"].remove(doc._id, doc._rev);
                        }).then(function(result) {
                            console.log("pedidosRascunho delete ok", result);
                        }).catch(function(error) {
                            console.log("pedidosRascunho delete error", error);
                        }).finally(function() {
                            loading.hide();
                            alert(response.data.message);
                            self.$root.back();
                        });
                    })
                    .catch(error => {
                        console.log("submit() error", error)
                        loading.hide();
                        self.loading.submit = false;
                        if (!self.$root.internet.online) {
                            alert("Você está sem conexão com a internet. Fique tranquilo, os dados foram salvos e você poderá realizar o reenvio mais tarde.");
                        } else {
                            self.$root.db["pedidosRascunho"].get(self.form._id).then(function (doc) {
                                return self.$root.db["pedidosRascunho"].remove(doc._id, doc._rev);
                            }).then(function(result) {
                                console.log("pedidosRascunho delete ok", result);
                            }).catch(function(error) {
                                console.log("pedidosRascunho delete error", error);
                            }).finally(function() {

                            });                    
                            alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                        }
                    });
                })
            });
        },
        getEmpresas: function() {
            var self        = this;
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "empresas",                    
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/empresas.php", form)
                .then(response => {
                    
                    self.empresas       = response.data.result;
                    self.atualizarEmpresa();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }, 
        getEstoque: function() {
            var self        = this;
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "estoque",                    
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "group":        false
                    }
                };

                axios.get("api/estoque.php", form)
                .then(response => {
                    
                    self.estoque       = response.data.result;
                    resolve(response.data.result);
                    
                    if (self.$route.name == "EditarPedidos") {
                        setTimeout(function() {
                            self.atualizarEstoque();
                        }, 100);
                    }

                })
                .catch(error => {
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }, 
        getEstoqueMedicao: function() {
            var self        = this;
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "estoque",                    
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "medicao",
                        // "empresaCod":   self.form.empresaCod
                    }
                };

                axios.get("api/estoque.php", form)
                .then(response => {
                    
                    self.estoqueMedicao     = response.data.result;
                    self.$forceUpdate();
                    resolve(response.data.result);
                    
                    // if (self.$route.name == "EditarPedidos") {
                    //     setTimeout(function() {
                    //         self.atualizarEstoque();
                    //     }, 100);
                    // }

                })
                .catch(error => {
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));                
                });   
            });   
        },         
        getPrecosEspeciais: function() {
            var self        = this;
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "precosEspeciais",                    
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "mes":          (new Date().getMonth()+1),
                        "ano":          (new Date().getFullYear()),
                        "group":        false
                    }
                };

                axios.get("api/precos-especiais-v2.php", form)
                .then(response => {
                    
                    self.precosEspeciais    = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },                  
        getCatalogo: function() {
            var self        = this;
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "db":               "catalogo",                    
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "catalogo",
                        "ordem":        "id ASC"
                    }
                };

                axios.get("api/catalogo.php", form)
                .then(response => {
                    
                    self.catalogo       = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },   
        atualizarPontos: function() {
            var self            = this;
            self.form.pontos    = Math.floor(self.form.quantidade / 20);
        },  
        atualizarItens: function() {
            var self = this;

            if (self.form.itens.length == 0) {

                self.catalogo.itens.forEach(function(item) {
                    self.form.itens.push({
                        "cod":          item.cod,
                        "nome":         item.nome,
                        "quantidade":   0,
                        "valor":        item.valor,
                        "total":        0
                    })
                });
            }
        },          
        get: function() {
            var self        = this;
            loading.show();
            return new Promise(function(resolve, reject) {
                var form = {
                    "db":               "pedidos",                    
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/pedidos.php", form)
                .then(response => {
                    
                    self.form           = response.data.result;
                    self.form.pedidoCod = response.data.result.cod;
                    self.loaded         = true;

                    $(".campo-contratante .autocomplete-input").attr("placeholder", response.data.result.contratante.nome);
                    if (response.data.result.cliente) {
                        $(".campo-cliente .autocomplete-input").attr("placeholder", (response.data.result.cliente.razaoSocial ? response.data.result.cliente.razaoSocial : response.data.result.cliente.nome));
                    }

                    if (self.form.observacoes) {
                        self.form.observacoes = self.form.observacoes.replaceAll("\\n", '\n');
                    }

                    console.log("STATUS", response.data.result.status)
                    if (response.data.result.status >= 2) {
                        setTimeout(function() {
                            self.$router.currentRoute.meta.title = "Editar";
                            self.$forceUpdate();
                            self.$root.$forceUpdate();
                            console.log("Setou titulo", self.$router.currentRoute)
                        }, 1000);
                    }

                    if (self.form.assinatura) {
                        $(".assinatura-preview").attr("src", self.$root.config.url + '/' + response.data.result.assinatura);                   
                        $(".assinatura-preview").show();
                    }

                    self.atualizarPontos();
                    self.atualizarItens();

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        getRascunho: function() {
            var self        = this;
            return new Promise(function(resolve, reject) {
                self.$root.db["pedidosRascunho"].get(self.form._id).then(function (doc) {
                    console.log("Existe rascunho", doc)
                    self.form = doc.request;
                    if (doc.request.assinatura) {
                        $(".assinatura-preview").attr("src", doc.request.assinatura);                   
                        $(".assinatura-preview").show();
                    }
                    self.$refs.contratanteNome.setValue(self.form.contratante);        
                    self.$refs.clienteNome.setValue(self.form.cliente);        

                    self.$forceUpdate();
                    resolve(doc);
                }).catch(function(error) {
                    console.log("Erro ao buscar rascunho", error);
                    resolve(error);
                });
            });
        },
        init: function() {
            var self = this;
            if (self.$route.name == "EditarPedidos") {
                if (!self.$route.query.c) {
                    self.$root.back();
                    return false;
                }
                self.form.cod   = self.$route.query.c;
                Promise.all([
                    self.getCatalogo(),
                    self.get(),
                    self.getEmpresas(), 
                    self.getEstoque(), 
                    self.getEstoqueMedicao(), 
                    self.getPrecosEspeciais()
                ]).then(function() {
                    setTimeout(function() {
                        self.form._id   = self.form.cod;
                        self.atualizarValorTotal();
                    }, 500);
                    loading.hide();
                }).catch(function(error) {
                    loading.hide();
                });
            } else {
                if (!self.$route.query._id) {
                    self.form._id   = md5((new Date().getTime()) + Math.random());
                } else {
                    self.form._id   = self.$route.query._id;
                }
                console.log("setou id", self.form._id)


                // loading.hide();
                Promise.all([
                    self.getEmpresas(), 
                    self.getEstoque(), 
                    self.getEstoqueMedicao(), 
                    self.getPrecosEspeciais(), 
                    self.getCatalogo(),
                    self.getRascunho()
                ]).then(function() {

                    loading.hide();
                }).catch(function(error) {
                    loading.hide();
                }); 
            }
            if (self.$root.user.tipo == "prestador") {
                self.form.empresaCod = self.$root.user.empresaCod;
            }

            if (self.$route.name == "EditarVendas" || self.$route.name == "CadastrarVendas") {
                self.form.finalidade    = "Venda a granel"
            }   

            // self.searchAutocompleteCliente("");         
            // self.searchAutocompleteContratante("");         
        }  
    },    
    created: function() {
        var self = this;

        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.init();
            });
        } else {
            self.init();
        }            
    },
    mounted: function() {
        var self = this;

        if (self.$root.tmp) {
            if (self.$root.tmp.tipo == "GerenciarUsuarios") {
                self.form.usuarioCod    = self.$root.tmp.valor.cod;
                self.$refs.contratanteNome.setValue(self.$root.tmp.valor);        
            }
        }

        if (self.$route.query.t == "agendar") {
            self.form.agendamento = 1;
        } else if (!self.$route.query.c) {
            self.form.data  = (new Date().toISOString()).toString().split("T")[0];
        }
        if (self.$root.user.tipo != "contratante") {
            self.getClientesDB();
            self.getUsuariosDB();
        }
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
    .page-cadastrarvendas .dashboard-box h3, .page-editarvendas .dashboard-box h3, .page-cadastrarpedidos .dashboard-box h3, .page-editarpedidos .dashboard-box h3 {
        border-bottom: 1px solid #ddd;
        padding-bottom: 8px;
        margin-bottom: 25px;
        color: #000;
    }

    .page-cadastrarvendas .dashboard-box h3 i, .page-editarvendas .dashboard-box h3 i, .page-cadastrarpedidos .dashboard-box h3 i, .page-editarpedidos .dashboard-box h3 i {
        color: #FF4000;
    }    

    .hr {
        border-top: 1px solid #ddd;
        margin-bottom: 20px;
    }

    .modal-assinatura canvas {
        width: 100%;
        min-height: 250px;
        border: 1px solid #ddd;
    }

    .modal-assinatura hr {
        position: relative;
        bottom: 80px;
    }

    .modal-assinatura button.gray {
        float: left;
    }

    .modal-assinatura button.green {
        float: right;
    }    

    .modal-assinatura button.transparent {
        float: right;
        background: transparent !important;
        border: 1px solid #ddd;
        margin-left: 5px;
        color: #000;
        height: 37px;
    }        

    .assinatura-preview {
        display: none;
        border: 1px solid #ddd;
        padding: 10px;
        width: 100%;
        max-width: 300px;
        margin-bottom: 20px;
        height: auto !important;
        /*max-height: 100px;*/
        /*float: right;*/
    }

    .page-cadastrarvendas .table-bordered input, .page-editarvendas .table-bordered input, .page-cadastrarpedidos .table-bordered input, .page-editarpedidos .table-bordered input {
        text-align: center;
        padding: 0px;
        margin: 0px !important;
        border: 1px solid #ddd;
    }

    @media only screen and (max-width: 500px) { 
        .assinatura-preview {
            max-width: 100%;
        }
        .modal-assinatura h3 {
            padding-top: 60px;
        }
    }

    @media (min-width: 480px) 
           and (max-width: 800px)
           and (orientation: landscape) {    

        .modal-assinatura .tingle-modal-box {
            width: 100% !important;
            margin: 0px !important;
            height: 100% !important;
        }
        .modal-assinatura {
            padding-top: 0px !important;
            padding-bottom: 0px !important;
            overflow: hidden !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/GerenciarPedidos.vue